import Vue from 'vue';

// ref: https://github.com/vuejs/vue-cli/issues/2417#issuecomment-436829272
export abstract class Base<P> extends Vue {
  public props!: Readonly<{ ref?: string | undefined }> & Readonly<P>;
}
